import { Dialog, Paper, useTheme } from '@mui/material'
import { useIsIcebergGrDevs } from '@src/providers/UserProvider'
import { ReactNode, type JSX } from 'react'
import Layout from '../containers/App/AppHeader'
import { useIsDeprecated } from '../data/selectors/app-config-selectors'

interface Props {
  children?: ReactNode
}

const FullScreenContainer = ({ children }: Props): JSX.Element => {
  const isIcebergGrDevs = useIsIcebergGrDevs()
  const deprecated = useIsDeprecated()
  const hasAlertBanner = isIcebergGrDevs || (import.meta.env.PROD && deprecated)
  const theme = useTheme()

  return (
    <Paper>
      <Dialog
        slotProps={{
          paper: {
            style: {
              backgroundColor: theme.palette.background.default,
              background: theme.palette.background.default,
              display: 'flex',
              flexDirection: 'column',
            },
          },
        }}
        fullScreen
        open
      >
        <Layout hasAlertBanner={hasAlertBanner} />
        <div
          style={{
            paddingLeft: '5rem',
            paddingRight: '5rem',
            flex: 1,
            minHeight: 0,
            overflow: 'auto',
          }}
        >
          {children}
        </div>
      </Dialog>
    </Paper>
  )
}

export default FullScreenContainer
